import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { LogedUser } from './logedUser.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly baseUrl = `${environment.base_url}/session`;
  private readonly USER_ID_KEY = 'user_id';
  private readonly TOKEN_KEY = 'auth_token';

  constructor(private http: HttpClient) {}

  // Simula chamada para backend e retorna true se sucesso
  login(login: string, password: string): Observable<LogedUser> {
    return this.http.post<LogedUser>(`${this.baseUrl}/login`, {login, password});

    // // Aqui você faria a chamada real para a API
    // // Exemplo fictício: se email e senha iguais a "admin@teste.com" / "123456" retorna sucesso
    // if (email === 'admin@teste.com' && password === '123456') {
    //   // Simula token JWT
    //   const fakeToken = 'token1234567890';
    //   localStorage.setItem(this.TOKEN_KEY, fakeToken);
    //   return true;
    // }

    // return false;
  }

  logout() {
    localStorage.removeItem(this.TOKEN_KEY);
  }

  isAuthenticated(): boolean {
    return !!localStorage.getItem(this.TOKEN_KEY);
  }

  getToken(): string | null {
    return localStorage.getItem(this.TOKEN_KEY);
  }

  getLoggedUserId(): number | null {
    const raw = localStorage.getItem(this.USER_ID_KEY);
    if (!raw) {
      return null;
    }
    const parsed = Number(raw);
    return Number.isNaN(parsed) ? null : parsed;
  }
}
